import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Workflow = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 1.5H8.75V1H7.25V1.5H5C4.17157 1.5 3.5 2.17157 3.5 3V3.75C3.5 4.57843 4.17157 5.25 5 5.25H7.25V6.125H5C4.17157 6.125 3.5 6.79657 3.5 7.625V8.375C3.5 9.20343 4.17157 9.875 5 9.875H7.25V10.5H5C4.17157 10.5 3.5 11.1716 3.5 12V12.75C3.5 13.5784 4.17157 14.25 5 14.25H7.25V15H8.75V14.25H11C11.8284 14.25 12.5 13.5784 12.5 12.75V12C12.5 11.1716 11.8284 10.5 11 10.5H8.75V9.875H11C11.8284 9.875 12.5 9.20343 12.5 8.375V7.625C12.5 6.79657 11.8284 6.125 11 6.125H8.75V5.25H11C11.8284 5.25 12.5 4.57843 12.5 3.75V3C12.5 2.17157 11.8284 1.5 11 1.5ZM11 3H5V3.75H11V3ZM11 12H5V12.75H11V12ZM5 7.625H11V8.375H5V7.625Z"
      fill="currentColor"
    />
  </Icon>
));

export default Workflow;
